/**
 * 작성자 : 홍선영
 * 날짜 : 2025.09.05
 * 경로 : (본사) 방문자 관리 - 방문자 현황
 */
import { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { ITabObject } from 'customTypes';
import { IUser, pageInfoState, themeState, userState } from '../../atoms';
import Tab from '../../components/Tab';
import Visit from '../s_attend/attend9/visit';
import VisitEdu from '../s_attend/attend9/visitEdu';
import { apiGet } from '../../services/_common';
import { useQuery } from '@tanstack/react-query';
import hGuideL from '../../assets/images/common/h_guide_l.png';
import hGuideD from '../../assets/images/common/h_guide_d.png';
import { useTranslation } from 'react-i18next';

const Hvisitor1 = () => {
  const { t } = useTranslation();
  const isTheme = useRecoilValue(themeState); // 테마 상태
  const size = useOutletContext<any>();
  const tabInfo = useRecoilValue(pageInfoState);
  const [currentTabMrCd, setCurrentTabMrCd] = useState(tabInfo.defaultMrCd);
  const userInfo = useRecoilValue<IUser>(userState);
  const { userMenuList } = userInfo;
  const [newTabList, setNewTabList] = useState<ITabObject[]>();
  const { data, isError } = useQuery(['edutermSetting', userInfo.sCd], () => getVisitSettingAPI(), { enabled: !!userInfo.hCd && !!userInfo.sCd });

  useEffect(() => {
    const arr: any[] = [];
    userMenuList.map((v: any) => {
      const result = tabInfo?.tabList?.find((el: ITabObject) => el.mtCd === v.mtCd && el.mdCd === v.mdCd && el.mrCd === v.mrCd);
      if (result) {
        arr.push(result);
        setNewTabList(arr);
      }
    });
  }, [tabInfo.tabList]);

  const onClickTab = (tab: string) => {
    setCurrentTabMrCd(tab);
  };

  const getVisitSettingAPI = async () => {
    const { hCd, sCd } = userInfo;
    try {
      const res = await apiGet({ path: '/visit/setting', contentType: 'application/json', req: { hCd, sCd } });
      return res.data.data;
    } catch (err) {
      console.error('err : ', err);
      throw new Error('Error');
    }
  };

  const renderPage = () => {
    const activeTab = newTabList?.find((el: ITabObject) => el.mrCd === currentTabMrCd);
    const { sCd } = userInfo;

    if (sCd === '00000') {
      return (
        <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1rem', flexDirection: 'column' }}>
          <img src={isTheme === 'dark' ? hGuideD : hGuideL} alt='현장 선택 가이드' style={{ width: '100%', maxWidth: '580px', borderRadius: '1rem' }} />
          <p style={{ padding: '0.5rem 0.75rem', backgroundColor: 'var(--tonal-violet)', color: 'var(--filled-violet)', borderRadius: '0.25rem' }}>{t('좌측 사이드바 상단에 현장명을 선택해주세요')}</p>
        </div>
      );
    }
    if (activeTab !== undefined) {
      const { mrCd } = activeTab;
      switch (mrCd) {
        case '001':
          return <Visit showPhoto={data?.photoYn === 'Y'} showCarnum={data?.carnumYn === 'Y'} visitHnumYn={data?.visitHnumYn === 'Y'} visitBdateYn={data?.visitBdateYn === 'Y'} />;
      }
    }
    return undefined;
  };

  return (
    <div className='contents'>
      <div className='content-container oneColumn'>
        <Tab tabList={newTabList || tabInfo.tabList} currentTabMrCd={currentTabMrCd} setCurrentTabMrCd={setCurrentTabMrCd} onClickTab={onClickTab} size={size} />
        {renderPage()}
      </div>
    </div>
  );
};

export default Hvisitor1;
